import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './Panel.module.scss';
/* eslint-enable css-modules/no-unused-class */

export interface PanelFootProps {
  className?: string;
  children: React.ReactNode;
}

/** The inset footer of a Panel, with a line above it: a short note, a link or the actions. */
const PanelFootComponent: React.FC<PanelFootProps> = ({ className, children }) => (
  <div className={clsx(styles.foot, className)}>{children}</div>
);

export const PanelFoot = TypedMemo(PanelFootComponent);
